
import React from 'react';
import { connect } from 'react-redux';
import {DashboardContainer, VIMEO_ICON_TYPE, VimeoIcon} from "../../funcs/utils";
import {getCalculator} from "../../calculators/actions";
import {Calculators} from "../../../lib/templates";
import {DEVICE_WIDTH} from "../../../lib/constants";

const ABOUT_VIDEO_ID = "788161507";
const RETIREMENT_VIDEO_ID = "593400427";
const MAGI_VIDEO_ID = "621681916";

class RetirementCalculator_ extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      show_ira_video: false,
      show_magi_video: false,
    };
    this.footer_items = [];
  }

  componentDidMount = () => {
    getCalculator(Calculators.IRA_RETIRE)
      .then(result => {
        this.setState(result);
        this.initScripts(result.script_url, result.script_src);
        this.updateHTML();
      })
  }

  maybeUpdateFooterItems = () => {
    const do_medium = this.props.app.width < DEVICE_WIDTH.medium;
    this.footer_items.forEach(item => {
      item.style['font-size'] = do_medium ? "1rem" : "1.5rem";
    })
  }

  updateHTML = () => {
    const button_open = document.getElementById("magi_modal_open");
    const button_close = document.getElementById("magi_modal_close");
    const modal_div = document.getElementById(("exampleModal"));

    if (button_open && button_close && modal_div) {
      button_open.onclick = () => {
        modal_div.classList.add("show");
        modal_div.style.display = "block";
      }
      button_close.onclick = () => {
        modal_div.classList.remove("show");
        modal_div.style.display = "none";
      }
    }

    const results_div = document.getElementById("results");
    if (results_div !== null) {
      const obs = new MutationObserver(() => {
        this.footer_items =
          Array.from(
            results_div.getElementsByClassName("_footer_stat"));

        this.maybeUpdateFooterItems();
      });

      obs.observe(results_div, {
        attributes:    true,
        childList:     true,
        characterData: true
      });

    }
  }

  initScripts = (script_urls, script_srcs) => {
    // See https://stackoverflow.com/questions/34424845/adding-script-tag-to-react-jsx
    script_urls.forEach(url => {
      const script = document.createElement("script");

      script.src = url;
      script.async = true;

      document.body.appendChild(script);
    });
    // https://stackoverflow.com/questions/6432984/how-to-add-a-script-element-to-the-dom-and-execute-its-code/44902662
    script_srcs.forEach(src => {
      const script = document.createElement("script");
      script.type = 'text/javascript';
      script.appendChild(document.createTextNode(src));
      document.body.appendChild(script);
    });
  }

  render_videos = do_medium => {
    const span_style = {
      paddingLeft: "1rem",
    }
    const dump_video = (icon, video_id, label) => {
      return (
        <div>
          <VimeoIcon
            state={this.state}
            component={this}
            icon={icon}
            video_id={video_id}
            id={"vimeo_" + video_id}
          />
          <span style={span_style}>{label}</span>
        </div>
      )
    }
    return (
      <div>
        { dump_video(VIMEO_ICON_TYPE.AVATAR, ABOUT_VIDEO_ID, "About this calculator") }
        <div style={{paddingLeft: "5.1rem", fontWeight: "bold", paddingTop: "1rem"}}>
          Learn more about:
        </div>
        { dump_video(VIMEO_ICON_TYPE.PRIMER, RETIREMENT_VIDEO_ID, "Retirement plans") }
        { dump_video(VIMEO_ICON_TYPE.PRIMER, MAGI_VIDEO_ID, "Marginal Adjusted Gross Income") }
      </div>
    );
  }

  render = () => {
    const container_style = {
      position: "relative",
    }
    const button_container_style = {
      position: "absolute",
      left: "50%",
      top: "0",
    }
    const device = { width: this.props.app.width };
    const do_medium = this.props.app.width < DEVICE_WIDTH.medium;

    this.maybeUpdateFooterItems();

    return (
      <DashboardContainer
        device={device}
        title={"Retirement Calculator"}
        client={this.props.client}>
        <div style={container_style}>
          <div dangerouslySetInnerHTML={{ __html: this.state.html}} />
          <div style={button_container_style}>
            { !do_medium && this.render_videos(do_medium) }
          </div>
        </div>
        <div>
          { do_medium && this.render_videos(do_medium) }
        </div>
      </DashboardContainer>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
  };
}

const mapStateToProps = state => {
  return {
    client: state.client,
    app: state.app,
  };
}

const RetirementCalculator =
  connect(mapStateToProps, mapDispatchToProps)(RetirementCalculator_);

export { RetirementCalculator };
